var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAustraliaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "country-flags",
    clipPath: "url(#clip0_2759_2888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87262 24 0.5 18.6274 0.5 12C0.5 12.0028 12.5 0.00135937 12.5 0C19.1274 0 24.5 5.37262 24.5 12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5013 0C12.5002 0 12.4991 7.61719e-05 12.498 7.61719e-05L12.5013 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4678 11.9991H12.4999C12.4999 11.9885 12.4999 11.9784 12.4999 11.9679C12.4892 11.9783 12.4785 11.9887 12.4678 11.9991Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5 6.26099C12.5 4.14951 12.5 2.7659 12.5 0.000137329H12.498C5.8715 0.00121545 0.5 5.37332 0.5 12.0001H6.76086V8.47452L10.2864 12.0001H12.4679C12.4787 11.9894 12.4894 11.9787 12.5 11.968C12.5 11.1595 12.5 10.4382 12.5 9.7866L8.97444 6.26099H12.5Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.57124 1.56519C4.69441 2.63389 3.13413 4.19417 2.06543 6.071V12H5.19588V4.69568V4.69564H12.5002C12.5002 3.70831 12.5002 2.76772 12.5002 1.56519H6.57124Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.4998 10.5243L8.23641 6.26095H6.76074C6.76074 6.2609 6.76074 6.26095 6.76074 6.26095L12.4998 12H12.4998C12.4998 12 12.4998 10.9826 12.4998 10.5243Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.73726 14.087L8.39585 15.4641L9.88306 15.1203L9.21706 16.4939L10.413 17.4423L8.92395 17.7779L8.92812 19.3043L7.73726 18.3494L6.54645 19.3043L6.55062 17.7779L5.06149 17.4423L6.25751 16.4939L5.59141 15.1203L7.07871 15.4641L7.73726 14.087Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.4667 16.6956L18.796 17.3842L19.5397 17.2123L19.2066 17.8991L19.8046 18.3733L19.0601 18.5411L19.0621 19.3043L18.4667 18.8268L17.8713 19.3043L17.8734 18.5411L17.1289 18.3733L17.7269 17.8991L17.3939 17.2123L18.1374 17.3842L18.4667 16.6956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.4033 9.39133L15.7326 10.0799L16.4762 9.90798L16.1432 10.5947L16.7412 11.069L15.9967 11.2368L15.9987 12L15.4033 11.5225L14.8079 12L14.8099 11.2368L14.0654 11.069L14.6634 10.5947L14.3304 9.90798L15.074 10.0799L15.4033 9.39133Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.4667 5.21738L18.796 5.90597L19.5397 5.73408L19.2067 6.42085L19.8046 6.89503L19.0601 7.06289L19.0621 7.82611L18.4667 7.3486L17.8713 7.82611L17.8734 7.06289L17.1289 6.89503L17.7268 6.42085L17.3939 5.73408L18.1374 5.90597L18.4667 5.21738Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.1426 8.34781L21.4718 9.0364L22.2154 8.86446L21.8824 9.55123L22.4804 10.0255L21.7359 10.1933L21.7379 10.9565L21.1426 10.479L20.5472 10.9565L20.5492 10.1933L19.8047 10.0255L20.4026 9.55123L20.0696 8.86446L20.8132 9.0364L21.1426 8.34781Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M19.229 12L19.488 12.7972H20.3262L19.6481 13.2899L19.9071 14.087L19.229 13.5943L18.5509 14.087L18.8099 13.2899L18.1318 12.7972H18.97L19.229 12Z",
    fill: "#F0F0F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_2888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaFlag);
export default __webpack_public_path__ + "static/media/australia-flag.1ddc9a7068ea2e0985faafb9d74f87b5.svg";
export { ForwardRef as ReactComponent };